export const langNotFound = {
  lost: {
    ua: 'Схоже, ти заблукав',
    en: "Looks like you're lost",
  },
  pageNotFound: {
    ua: 'сторінка, яку ти шукаєш, недоступна!',
    en: 'the page you are looking for not avaible!',
  },
  goBack: {
    ua: 'Повернутись назад',
    en: 'Go back',
  },
};